import createTableSelectionStore from "ds/components/Table/store/useTableSelectionStore";

const useStackRolesTableSelectionStore = createTableSelectionStore();

export default useStackRolesTableSelectionStore;